/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
} from '@msdyn365-commerce/core';
import { getConfigurationAsync } from '../../../data-actions/generated/DataActionExtension.g';
import { IDXC_GetConfigurationResponse } from '../../../data-actions/generated/DataServiceEntities.g';

/**
 * AfterpayGetConfigDataAction Input Action
 */

export class AfterpayGetConfigDataActionInput implements IActionInput {
    // public id: string;
    // // TODO: Construct the input needed to run the action

    // constructor (id: string) {
    //     this.id = id;
    // }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `AfterpayConfigKey`;
    public getCacheObjectType = () => 'AfterpayConfig';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
// export interface IAfterpayGetConfigDataActionData {
//     text: string;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: AfterpayGetConfigDataActionInput): IActionInput => {
    return args;
};

async function getAfterpayConfigAction(
    input: AfterpayGetConfigDataActionInput,
    ctx: IActionContext
): Promise<IDXC_GetConfigurationResponse> {
    const result: IDXC_GetConfigurationResponse = await getConfigurationAsync({ callerContext: ctx });

    return Array.isArray(result) ? result[0] : result;
}

export const IAfterpayGetConfigDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_GetConfigurationResponse>>getAfterpayConfigAction,
    input: createInput
});
